// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingPage_backdrop__o8Lju","spinner":"LoadingPage_spinner__pTWJn","spin":"LoadingPage_spin__IIBqb"};